import { api } from "@/api";
import {
  AddSportMappingParams,
  SportProviderMappingDto,
} from "@/types/ApiResponses/Sport";

export const addSportMapping = async (
  params: AddSportMappingParams
): Promise<SportProviderMappingDto> => {
  const { sportId, ...body } = params;
  const res = await api.client.post(`/sports-new/${sportId}/mappings`, body);
  return res.data;
};
